import React from 'react';
import { motion, HTMLMotionProps } from 'framer-motion';
interface ButtonProps extends HTMLMotionProps<'button'> {
  variant?: 'primary' | 'secondary' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  children: React.ReactNode;
  className?: string;
}
export function Button({
  variant = 'primary',
  size = 'md',
  children,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-display uppercase tracking-wider transition-colors focus:outline-none focus:ring-2 focus:ring-iris-green focus:ring-offset-2 focus:ring-offset-iris-black disabled:opacity-50 disabled:cursor-not-allowed';
  const variants = {
    primary: 'bg-iris-green text-white hover:bg-iris-greenLight',
    secondary: 'bg-iris-surface border border-iris-border text-iris-text hover:border-iris-green hover:text-iris-greenLight',
    ghost: 'bg-transparent text-iris-text hover:text-iris-greenLight'
  };
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg'
  };
  return <motion.button whileTap={{
    scale: 0.98
  }} className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`} {...props} data-id="element-308">
      {children}
    </motion.button>;
}